import { render, staticRenderFns } from "./liveabcxwordup.vue?vue&type=template&id=690d6e8c&scoped=true&"
import script from "./liveabcxwordup.vue?vue&type=script&lang=js&"
export * from "./liveabcxwordup.vue?vue&type=script&lang=js&"
import style0 from "./liveabcxwordup.vue?vue&type=style&index=0&id=690d6e8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "690d6e8c",
  null
  
)

export default component.exports